import { TextField, Typography, useTheme } from '@mui/material';
import { BudgetBys } from 'business/constants';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { BudgetSettingsUrlParams } from 'routes/Admin/Budget/BudgetSettings';
import { BudgetProposalWithResourcesT } from 'routes/BudgetModule/config/types';
import { AutocompletAble } from 'ui/DropdownItems/types';
import { getResourcesTranslation } from '../../DuplicateSettings/helpers';
import { camelize } from 'helpers/syntaxHelper';

type Props = {
    existingInscriptionsAction: AutocompletAble<string> | null;
    selectedBudgetProposals:
        | AutocompletAble<BudgetProposalWithResourcesT>[]
        | null;
    confirmationIsValid: boolean;
    setConfirmationIsValid: DispatchState<boolean>;
};

export default function FifthStep({
    existingInscriptionsAction,
    selectedBudgetProposals,
    confirmationIsValid,
    setConfirmationIsValid,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const theme = useTheme();
    const confirm = t('common.confirm').toLowerCase();
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        const keywordMatches = value.toLowerCase().trim() === confirm;
        setConfirmationIsValid(keywordMatches);
    };
    const { by: selectedBy = BudgetBys.GESTIONNAIRE } =
        useParams<BudgetSettingsUrlParams>();
    const budgetProposalsComponentList = selectedBudgetProposals?.map(
        (budgetProposal) => (
            <Typography
                component="span"
                key={budgetProposal.value.id}
                sx={{
                    color: theme.palette.primary.main,
                    fontWeight: 'bold',
                    paddingLeft: '1em',
                    display: 'block',
                }}
            >
                {budgetProposal.value.name}
            </Typography>
        ),
    );
    const i18nKey = `adminBudgetSpace.initInscriptions.fifthStepText.${camelize(existingInscriptionsAction?.value || '')}`;
    return (
        <>
            <Typography variant="h4" sx={{ paddingBottom: '1.5em' }}>
                {t('adminBudgetSpace.initInscriptions.title')}
            </Typography>
            <Typography sx={{ whiteSpace: 'break-spaces' }}>
                <Trans
                    i18nKey={i18nKey}
                    components={{
                        bold: (
                            <strong
                                style={{
                                    color: theme.palette.primary.main,
                                }}
                            />
                        ),
                        list: <>{budgetProposalsComponentList}</>,
                    }}
                    values={{
                        resources: getResourcesTranslation(selectedBy),
                    }}
                />
            </Typography>
            <TextField
                placeholder={confirm}
                onChange={onChange}
                size="small"
                error={!confirmationIsValid}
                sx={{ mt: 2 }}
            />
        </>
    );
}
